/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ButtonTokenFactory,
  ButtonTokenFactoryInterface,
} from "../ButtonTokenFactory";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_template",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "instance",
        type: "address",
      },
    ],
    name: "InstanceAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "instance",
        type: "address",
      },
    ],
    name: "InstanceRemoved",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "underlying",
        type: "address",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "oracle",
        type: "address",
      },
    ],
    name: "create",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "args",
        type: "bytes",
      },
    ],
    name: "create",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "instanceAt",
    outputs: [
      {
        internalType: "address",
        name: "instance",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "instanceCount",
    outputs: [
      {
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "instance",
        type: "address",
      },
    ],
    name: "isInstance",
    outputs: [
      {
        internalType: "bool",
        name: "validity",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "template",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ButtonTokenFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ButtonTokenFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ButtonTokenFactory__factory extends ContractFactory {
  constructor(...args: ButtonTokenFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _template: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ButtonTokenFactory> {
    return super.deploy(
      _template,
      overrides || {}
    ) as Promise<ButtonTokenFactory>;
  }
  getDeployTransaction(
    _template: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_template, overrides || {});
  }
  attach(address: string): ButtonTokenFactory {
    return super.attach(address) as ButtonTokenFactory;
  }
  connect(signer: Signer): ButtonTokenFactory__factory {
    return super.connect(signer) as ButtonTokenFactory__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ButtonTokenFactoryInterface {
    return new utils.Interface(_abi) as ButtonTokenFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ButtonTokenFactory {
    return new Contract(address, _abi, signerOrProvider) as ButtonTokenFactory;
  }
}
